/**
 * Scoring (GDD §4.7), extra jets (GDD §4.6, D11) and the high score (D20).
 */
import { config } from '../core/config.ts';
import { pushEvent, type GameSim } from '../sim/context.ts';
import type { EnemyType } from '../sim/state.ts';

/** Points for destroying each enemy type (GDD §4.7). */
export function points(type: EnemyType): number {
  const s = config.score;
  return type === 'ship' ? s.gunboat : type === 'heli' ? s.heli : type === 'fuel' ? s.fuel : s.jet;
}

/**
 * Adds points (concept L955). Under GDD rules every 10,000 points earns a jet, up to 5; a threshold crossed with 5
 * jets is not banked (judgment call 8).
 */
export function addScore(sim: GameSim, p: number): void {
  const run = sim.run;
  run.score += p;
  if (sim.rules !== 'gdd') return;
  const l = config.lives;
  while (run.score >= run.nextExtra) {
    run.nextExtra += l.extraEvery;
    if (run.lives < l.max) {
      run.lives++;
      pushEvent(sim, 'extraJet');
    }
  }
}

/** The high score follows the score (concept L1208); under GDD rules only in a player's run (judgment call 23). */
export function updateHigh(sim: GameSim): void {
  const run = sim.run;
  if (sim.rules === 'gdd' && !run.player) return;
  if (run.score > run.hi) run.hi = run.score;
}
